import * as THREE from 'three';

// 1. 文本Sprite生成器（带缓存）
const textCache = new Map();

export function createSpriteEnum(text, options = {}) {
  // 参数合并
  const {
    fontSize = 40,
    color = '#00ff00',
    fontFamily = 'Arial',
    displayHeight = 0.2 // Three.js单位高度
  } = options;

  // 检查缓存
  if (textCache.has(text)) {
    return textCache.get(text).clone();
  }

  // 创建Canvas
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // 测量文本
  ctx.font = `Bold ${fontSize}px ${fontFamily}`;
  const textWidth = ctx.measureText(text).width;

  // 设置Canvas尺寸（带边距）
  canvas.width = Math.ceil(textWidth * 1.5); // 宽度=文本宽度+50%边距
  canvas.height = Math.ceil(fontSize * 2);   // 高度=字体大小×2

  // 绘制文本（居中）
  ctx.fillStyle = color;
  ctx.font = `Bold ${fontSize}px ${fontFamily}`;
  ctx.textBaseline = 'middle';
  ctx.fillText(
    text,
    canvas.width / 2 - textWidth / 2, // 水平居中
    canvas.height / 2                 // 垂直居中
  );

  // 创建Three.js对象
  const texture = new THREE.Texture(canvas);
  texture.needsUpdate = true;

  const material = new THREE.SpriteMaterial({
    map: texture,
    transparent: true,
    depthTest: false
  });

  const sprite = new THREE.Sprite(material);
  
  // 按显示高度等比缩放
  const aspect = canvas.width / canvas.height;
  sprite.scale.set(aspect * displayHeight, displayHeight, 1);

  // 存入缓存
  textCache.set(text, sprite.clone());

  return sprite;
}
